import { HttpV1 as HTTP } from '@/request';

// 参数列表
export async function getParamList() {
    return HTTP.get(`/show/list`)
}